import React, { useContext as useContextCore } from 'react'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, value, setValue, ...props }: any) => {
  const [valueType, setValueType] = React.useState(undefined)
  const [newValue, setNewValue] = React.useState(undefined)

  const onChange = (e) => {
    setValue(e)
  }

  const isDynamic = (stringVal) => {
    return stringVal?.indexOf?.('<<') !== -1 && stringVal?.indexOf?.('<<') !== undefined
  }

  React.useEffect(() => {
    isDynamic(value) ? setValueType('dynamic') : setValueType('date')

    setNewValue(value)
  }, [value])

  return <CoreProvider value={{ valueType, setValueType, newValue, onChange, isDynamic, ...props }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
